module.exports = __webpack_public_path__ + "static/media/isabela.4a454cf4.png";